import { render, staticRenderFns } from "./WellBeing.vue?vue&type=template&id=91c26208"
import script from "./WellBeing.vue?vue&type=script&lang=js"
export * from "./WellBeing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports